/**
 * The shell and the route table.
 *
 * Phase 6: the Cash Drop submit form is the landing screen (`/`), and
 * Massiel's reconciliation table is always in the nav (`/reconciliation`) -
 * per the phase 6 doc's "Roles" ruling, the link is shown to every signed-in
 * account regardless of role, since the frontend is never told what that role
 * is (D-7) and the screen itself renders whatever the API actually returns.
 * Diagnostics stays at `/about`, unchanged, for ops/debugging - it is not a
 * manager-facing screen and this phase does not remove it.
 *
 * Safe Count (docs/phases/safe-count.md): its submit form is at
 * `/safe-count`, and its viewer-gated list is a second entry in the
 * reconciliation area (`/reconciliation/safe-count`), reached through the
 * sub-nav both reconciliation screens share. Same D-7 rule: the links are
 * always there, the screens render what the API says.
 *
 * Petty Cash (docs/phases/petty-cash-consolidation.md): its submit form is at
 * `/petty-cash`, and its ledger/reconciliation view is a third sub-nav entry
 * (`/reconciliation/petty-cash`). Same D-7 rule again.
 */
import { Link, Route, Routes } from "react-router-dom";

import { AuthProvider } from "./auth/AuthProvider";
import { Diagnostics } from "./screens/Diagnostics";
import { PettyCashReconciliation } from "./screens/PettyCashReconciliation";
import { Reconciliation } from "./screens/Reconciliation";
import { SafeCountReconciliation } from "./screens/SafeCountReconciliation";
import { SubmitCashDrop } from "./screens/SubmitCashDrop";
import { SubmitPettyCash } from "./screens/SubmitPettyCash";
import { SubmitSafeCount } from "./screens/SubmitSafeCount";

export function App() {
  return (
    <AuthProvider>
      <div className="app">
        <header className="app-header">
          <Link to="/" className="app-header__title">
            La Segunda Cash Forms
          </Link>
          <nav>
            <Link to="/">Cash Drop</Link>
            <Link to="/safe-count">Safe Count</Link>
            <Link to="/petty-cash">Petty Cash</Link>
            <Link to="/reconciliation">Reconciliation</Link>
            <Link to="/about">Diagnostics</Link>
          </nav>
        </header>

        <main className="app-main">
          <Routes>
            <Route path="/" element={<SubmitCashDrop />} />
            <Route path="/safe-count" element={<SubmitSafeCount />} />
            <Route path="/petty-cash" element={<SubmitPettyCash />} />
            <Route path="/reconciliation" element={<Reconciliation />} />
            <Route path="/reconciliation/safe-count" element={<SafeCountReconciliation />} />
            <Route path="/reconciliation/petty-cash" element={<PettyCashReconciliation />} />
            <Route path="/about" element={<Diagnostics />} />
            <Route path="*" element={<SubmitCashDrop />} />
          </Routes>
        </main>
      </div>
    </AuthProvider>
  );
}
